import { Type } from 'class-transformer';
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { CBVendorSelectorResultDto } from '../../common/cb-vendor-selector-result-dto';
import { UpdatedResultDto } from '../../common/updated-result-dto';
import { APAdjustmentItemResultDto } from './ap-adjustment-item-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';

export class APAdjustmentResultDto {
    apAdjustmentId: number;
    adjustmentType: string;
    managementCompanyId: number;
    managementCompanyName: string;
    communityId: number;
    communityName: string;
    debitOrCredit: string;

    @Type(() => Date)
    docDate: Date;

    @Type(() => Date)
    postDate: Date;

    @Type(() => Date)
    deletedDate: Date;

    @Type(() => Date)
    reversedDate: Date;

    description: string;
    amount: number;
    openBalance: number;
    hasCreditApplications: boolean;

    referenceType: string;
    referenceId: number;
    referenceNumber: number;
    additionalInfoDisplayText: string;
    reversalAdjustmentId: number;

    allowReverse: boolean;
    allowApplyDebit: boolean;
    allowDelete: boolean;

    /*
        If AllowLimitedEdit and AllowEdit both are true then user can modify any property at Header and line level.
        If only AllowLimitedEdit is true then user can modify Document date, description at header level and Line item description
    */
    allowEdit: boolean;
    allowLimitedEdit: boolean;

    allowReclassify: boolean;

    @Type(() => CBVendorSelectorResultDto)
    vendor: CBVendorSelectorResultDto;

    @Type(() => APAdjustmentItemResultDto)
    items: APAdjustmentItemResultDto[];

    @Type(() => UpdatedResultDto)
    lastUpdated: UpdatedResultDto;

    @Type(() => FileInfoDisplayResultDto)
    attachments: FileInfoDisplayResultDto[];

    @Type(() => KeyValueResultDto)
    requiredDimensions: Array<KeyValueResultDto>;

    entityUsesSubCategory: boolean;

    /*
        Added two new fields showRequiredDimension & glDimensions for apply debit dimesnion seletor.
    */
    showRequiredDimension: boolean;

    @Type(() => DimensionSelectorResultDto)
    glDimensions: DimensionSelectorResultDto[];

    get referenceTypeText(): string {
        let refText = '';

        switch (this.referenceType) {
            case 'P':
                refText = 'Payment';
                break;
            case 'A':
                refText = 'Adjustment';
                break;
            case 'B':
                refText = 'Bill';
                break;
        }

        return `(Original AP ${refText})`;
    }
}
